import React from "react";
import {
	View,
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import StyledButton from "./StyledButton.js";
import Style from "ae-style";

import { useResources } from "@aetonix/hooks";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		container: {
			flexDirection: "row"
		},
		button: {
			justifyContent: "center",
			flex: 1
		},
		buttonPadding: {
			padding: Style.layout.paddingSmall
		}
	},
	512: {
		container: {
			flexDirection: "row",
		},
		button: {
			justifyContent: "center",
			flex: 1
		}
	}
});

export default function BackButton(props){
	const title = props.title;
	const children = props.children;
	const { dispatch } = useResources();
	const id = props.id || "back_button";

	let backAction = null;
	if(props.goHome) {
		backAction = dispatch("desktop:trigger:page:home");
	}else {
		backAction = dispatch("desktop:trigger:page:back");
	}
	const onPress = props.onPress || backAction;

	const noContrast = props.noContrast;

	return (
		<View style={styles.container}>
			<View style={styles.button}>
				<StyledButton testID={id} title={title} clear contrast={!noContrast} icon="left" onPress={onPress} style={styles.buttonPadding} />
			</View>
			{children}
		</View>
	);
}
